<template>
    <div>
        <banner1></banner1>
        <version :version_animation="version_animation"></version>
        <service :service_animation="service_animation"></service>
        <choose :choose_animation="choose_animation"></choose>
        <project :project_aimation="project_aimation"></project>
        <chinamap :map_animation="map_animation"></chinamap>
        <chat :chatAnimation="chat_animation" @changeChat="changeChat"></chat>
    </div>
</template>

<script>
import banner from "./components/banner"
import banner1 from "./components/banner1"
import version from "./components/version"
import chinamap from "./components/chinamap"
import service from "./components/service"
import choose from "./components/choose"
import project from "./components/project"
import chat from './components/chat'
import Cookies from 'js-cookie'
import doPost from "@/pages/Helper/XHR.js"
export default {
    name: 'Home',
    components: {banner,version,chinamap,service,choose,project,chat,banner1},
    data () {
        return {
            version_animation: false,
            service_animation: false,
            map_animation: false,
            project_aimation: false,
            choose_animation: false,
            chat_animation: false,
            system: {
                android : false,
                iphone : false,
            },
        }
    },
    methods: {
        changeChat (data) {
            this.chat_animation = data
        },
        keywords () {
        getKeyWord(getReferer())
        function getReferer() {
            if (document.referrer) {
                return document.referrer;
            } else {
                return false;
            }
        }
        function setCookie(name,value){
          var cookieString = name+"="+value;
          document.cookie=cookieString;
        }
        function getCookie(name){
            var strCookie=document.cookie;
            var arrCookie=strCookie.split(";");
            for(var i=0;i < arrCookie.length;i++){
            var arr=arrCookie[i].split("=");
            if(arr[0]==name)return arr[1];
            }
            return "";
        }
        function getKeyWord(url) {
            const refer  = url
            const domain = window.location.href
            const sousuo = refer.toString().split(".")[1];
            let grep = null,str = null,keyword = null,fkeyword = null,mytype = null
            switch (sousuo) {
                case "baidu":
                    grep = /word\=.*\&/i;
                    str = refer.match(grep)
                    keyword = str == null ? '' : decodeURIComponent(str.toString().split("&")[0].split("=")[1])
                    console.log(keyword)
                    mytype = 1
                    doPost(
                      {action: 'get_key_word', keyword: keyword, domain: domain, ip: returnCitySN["cip"] ,type: mytype, domain_keyword:`${domain}${keyword}`},
                      (data) => {
                        console.log(data)
                    })
                    break;
                case "so":
                    grep = /&q\=.*/i;
                    str = refer.match(grep)
                    keyword = str == null ? '' : str.toString().split("=")[1]
                    console.log(keyword)
                    mytype = 2
                    doPost(
                      {action: 'get_key_word', keyword: keyword, domain: domain, ip: returnCitySN["cip"] ,type: mytype, domain_keyword:`${domain}${keyword}`},
                      (data) => {
                        console.log(data)
                    })
                    break;
                case "sogou":
                    grep = /&q\=.*/i;
                    str = refer.match(grep)
                    keyword = str == null ? '' : str.toString().split("=")[1]
                    console.log(keyword)
                    mytype = 3
                    doPost(
                      {action: 'get_key_word', keyword: keyword, domain: domain, ip: returnCitySN["cip"] ,type: mytype, domain_keyword:`${domain}${keyword}`},
                      (data) => {
                        console.log(data)
                    })
                    break;
            }
            Cookies.set('keyword',keyword)
            Cookies.set('domain',domain)
          }
        },
        pc_init () {
            this.version_animation = true
            this.chat_animation = true
            window.addEventListener("scroll",() => {
                var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
                var pages = document.querySelectorAll(".page")
                if(pages.style){
                    pages[pages.length-1].style.display = "block"
                }
               if(scrollTop){
                    if(pages.length == 0){
                        //修复 跳转其他组件的BUG
                        window.removeEventListener('scroll', this.pc_init)
                        return
                    }
                    if(scrollTop >= pages[1].offsetTop-526){
                        this.service_animation = true
                    }
                    if(scrollTop >= pages[2].offsetTop-526){
                        this.choose_animation = true
                    }
                    if(scrollTop >= pages[3].offsetTop-626){
                        this.project_aimation = true
                    }
                    if(scrollTop >= pages[4].offsetTop-526){
                        this.map_animation = true
                    }
               }
            })
        },
        mobil_init () {
            var pages = document.querySelectorAll(".page")
            pages[pages.length-1].style.display = "none"
            if(this.system.android || this.system.iphone){
                this.version_animation = true
                this.service_animation = true
                this.choose_animation = true
                this.project_aimation = true
                this.map_animation = true

                var domTop = document.querySelectorAll(".page-top")
                if(domTop.forEach){
                     domTop.forEach((item,index) => {
                        item.style.display = "none"
                    })
                }else{
                    //IE下兼容
                    for(var i=0;i<domTop.length;i++){
                        domTop[i].style.display = "none"
                    }
                }

                window.removeEventListener('scroll', this.pc_init)

                return
            }
        },
        init () {
            var userAgents = navigator.userAgent
            this.system.android = userAgents.indexOf("Android") >= 0 ? true : false
            this.system.iphone = userAgents.indexOf("iPhone") >= 0 ? true : false
            if(this.system.android || this.system.iphone){
                this.mobil_init() //移动UI
            }else{
                this.pc_init() //PC UI
            }
        }
    },
    mounted () {
        this.init()
        this.keywords()
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.pc_init)
    }
}
</script>

<style lang="stylus" scoped>
</style>





// WEBPACK FOOTER //
// src/pages/Home/Home.vue